// Self-contained 3-dot (kebab) menu that exposes the "Preview log" viewer.
//
// Drop it into any preview surface's header — it owns its dropdown state and
// the PreviewLogModal, so the host only needs to pass project + object. Used by
// the Visual and Dashboard preview modals (the transaction preview surfaces the
// same viewer through its existing DeployMenu instead).

import { useState } from 'react'
import { MoreVertical, FileText } from 'lucide-react'
import PreviewLogModal from './PreviewLogModal'

interface Props {
  projectName: string
  objectName?: string
}

export default function PreviewLogMenu({ projectName, objectName }: Props) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [logOpen, setLogOpen] = useState(false)

  return (
    <div style={{ position: 'relative' }}>
      <button
        className="btn btn-ghost btn-sm"
        onClick={() => setMenuOpen((v) => !v)}
        title="More"
        aria-label="More"
        style={{ padding: 6 }}
      >
        <MoreVertical size={16} />
      </button>

      {menuOpen && (
        <>
          {/* click-away catcher */}
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 1100 }}
            onClick={() => setMenuOpen(false)}
          />
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute', top: 'calc(100% + 4px)', right: 0,
              minWidth: 190, zIndex: 1101,
              background: 'var(--color-bg, #fff)', color: 'var(--color-text)',
              border: '1px solid var(--color-border)', borderRadius: 8,
              boxShadow: '0 8px 24px rgba(0,0,0,0.18)', padding: 4,
              display: 'flex', flexDirection: 'column',
            }}
          >
            <button
              onClick={() => { setMenuOpen(false); setLogOpen(true) }}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '7px 10px', fontSize: 14, textAlign: 'left',
                background: 'none', border: 'none', borderRadius: 6, cursor: 'pointer',
                color: 'var(--color-text)',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--color-bg-secondary, #f1f5f9)' }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'none' }}
            >
              <FileText size={14} /> <span>Preview log</span>
            </button>
          </div>
        </>
      )}

      <PreviewLogModal
        open={logOpen}
        onClose={() => setLogOpen(false)}
        projectName={projectName}
        objectName={objectName}
      />
    </div>
  )
}
